import 'angular:locale/data:pt';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "pt";
